module.exports = __webpack_public_path__ + "07_hair_silver.0293af5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/07_hair_silver.png
// module id = HcGp
// module chunks = 0